import createAction from 'Store/utils/createAction';
import { TRIP_INFORMATION_SET_DEPARTURE_DATE } from 'Store/constants';
type Payload = {
  departureDate: timestamp | null | undefined;
};

function setDepartureDate(departureDate: timestamp | null | undefined): Action<Payload> {
  return createAction(TRIP_INFORMATION_SET_DEPARTURE_DATE, {
    departureDate,
  });
}

export { setDepartureDate };
